export const SEARCH_DELAY = 500;

export const STATUS_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'closed', label: 'Closed' },
  { value: 'in_progress', label: 'WIP' },
];

export const PRIORITY_OPTIONS = [
  { value: 'critical', label: 'Critical' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
];

export const CREATED_BY_OPTIONS = [
  { value: 'yardi', label: 'Yardi' },
  { value: 'respondit', label: 'VoiceSphere' },
];
